import React from 'react';
import { string, oneOf } from 'prop-types';
import { EmptyPageFillerWrapper, Headline, HeadlineWrapper } from './EmptyPageFiller.styles';
import { Artworks } from '../..';
const {
  skyStars: SkyStarsIcon,
  graphStars: GraphStarsIcon
} = Artworks;
export const EmptyPageFiller = _ref => {
  let {
    firstLine,
    secondLine,
    icon
  } = _ref;
  return /*#__PURE__*/React.createElement(EmptyPageFillerWrapper, null, icon === 'skyStars' ? /*#__PURE__*/React.createElement(SkyStarsIcon, null) : /*#__PURE__*/React.createElement(GraphStarsIcon, null), /*#__PURE__*/React.createElement(HeadlineWrapper, null, /*#__PURE__*/React.createElement(Headline, null, firstLine), /*#__PURE__*/React.createElement(Headline, null, secondLine)));
};
EmptyPageFiller.propTypes = {
  firstLine: string.isRequired,
  secondLine: string.isRequired,
  icon: oneOf(['skyStars', 'graphStars'])
};
EmptyPageFiller.defaultProps = {
  icon: 'skyStars'
};